export default __webpack_public_path__ + "static/media/kayaguneribes9.16ed9adb.jpg";